import { ShipmentDto, ShipmentModel } from '../types/shipment'

export const transformShipmentDto = ({ id, status }: ShipmentDto): ShipmentModel => ({
  id,
  status,
})
